import type { LevelTableColumn } from 'redesign';
import { Cell, Header } from 'shared/components/planner/common/utils';
import {
  MinimumRateCellProp,
  MinimumRateColumnDefinition,
  MinimumRateTableOptions,
} from './minimum-rate-table.types';

export const getMinimumRateColumnDefinition: () => LevelTableColumn<
  MinimumRateColumnDefinition,
  MinimumRateTableOptions
>[] = () => {
  const jobTypeName: LevelTableColumn<MinimumRateColumnDefinition, MinimumRateTableOptions> = {
    Header: () => <Header>Functiegroep</Header>,
    accessor: 'name',
    Cell: Cell,
  };
  const minimumRate: LevelTableColumn<MinimumRateColumnDefinition, MinimumRateTableOptions> = {
    Header: () => <Header>Minimum tarief zzp'er</Header>,
    accessor: 'minimumRateToEuros',
    Cell: Cell,
    width: '200px',
  };
  const action: LevelTableColumn<MinimumRateColumnDefinition, MinimumRateTableOptions> = {
    Header: () => <Header>Actie</Header>,
    accessor: 'action',
    Cell: ActionCell,
    width: '65px',
  };

  return [jobTypeName, minimumRate, action];
};

const ActionCell = (cell: MinimumRateCellProp<'action'>) =>
  cell.getEditAction(cell.value.id, cell.value.minimumHourlyRate);
